import React from 'react';
import i18next from 'i18next';
import { string } from 'prop-types';
import { useSelector } from 'react-redux';

function IntercomButton({ className, textClassName }) {
  const { intercomId } = useSelector((state) => state.core.settings);

  return (
    !!intercomId && (
      <button type="button" className={`${className} intercomTriggerShow`}>
        <h5 className={`subtitle-small-light ${textClassName}`}>{i18next.t('ProfileLinks:onlineChat')}</h5>
      </button>
    )
  );
}

IntercomButton.propTypes = {
  textClassName: string.isRequired,
  className: string
};

IntercomButton.defaultProps = {
  className: ''
};

export default IntercomButton;
